module.exports = "/_next/static/images/40a291a41d14b4cd5e0c9be7a3d28761-woman-holding-device-smiling@0.5x.jpg.webp";